import React from 'react';
import "../styles.scss";

const ExperienceCard = ({ imgSrc, company, location, role, date, description, highlights, stack }) => {
    return (
        <article className="row project-card g-0">
            <div className="col-auto experience-logo-col">
                <img src={imgSrc || ""} width="60" height="60" alt={`${company} logo`} />
            </div>
            <div className="col experience-content">
                <div className="d-flex flex-column flex-lg-row justify-content-between align-items-start gap-2">
                    <div>
                        <p className="experience-company mb-1">{company} <span className="text-white-50">· {location}</span></p>
                        <h2 className='m-0 experience-role'>{role}</h2>
                    </div>
                    <p className="text-white-50 m-0 experience-date">{date}</p>
                </div>
                <p className="text-white experience-description mb-3">{description}</p>
                <div className="experience-pill-group">
                    {highlights.map((item) => (
                        <span className="experience-pill experience-pill-highlight" key={`${company}-${item}`}>{item}</span>
                    ))}
                </div>
                <div className="experience-pill-group experience-pill-group-stack">
                    {stack.map((item) => (
                        <span className="experience-pill" key={`${company}-stack-${item}`}>{item}</span>
                    ))}
                </div>
            </div>
        </article>
    );
};

export default ExperienceCard;
